// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a65fdd5b","256":"830d5295","453":"453f2ef2","514":"dccebff8","767":"2f8bf658"}[chunkId] + ".chunk.js";
};